export default class CustomFieldsService {
    constructor($equalOneUIService, $rootScope, $window) {
        this.$window = $window;
        this.customfields = $rootScope.config.customfields;
        this.equaloneUIService = $equalOneUIService;
        this.fields = this.load();
    }

    hasCustomFields() {
        if (this.customfields && this.customfields.length > 0) {
            return true
        }
        else {
            return false
        }
    }

    save(fields) {
        this.clear();
        if (typeof(this.$window.localStorage) !== "undefined") {
            let keys = "";
            for (let key of Object.keys(fields)) {
                if (fields[key] !== undefined &&  fields[key]!=="") {
                    this.$window.localStorage.setItem("customfield." + key, fields[key]);
                    keys += key + ";";
                }
            }
            this.$window.localStorage.setItem("customfield.__keys",keys);
            this.fields = this.load();
        } else {
            // Sorry! No Web Storage support..
        }
        this.sendCustomFields(fields);
    }

    load() {
        let fields = {};
        if (typeof(this.$window.localStorage) !== "undefined") {
            let keys = this.$window.localStorage.getItem("customfield.__keys");
            if (keys!=null) {
                let arrKeys = keys.split(';');
                for (let key of arrKeys) {
                    if (key !== "") {
                        fields[key] = this.$window.localStorage.getItem("customfield."+key);
                    }
                }
            }
        } else {
            // Sorry! No Web Storage support..
        }
        this.sendCustomFields(fields);
        return fields;
    }

    clear() {
        if (typeof(this.$window.localStorage) !== "undefined") {
            //this.$window.localStorage.getItem("customfield.__keys");
            let keys = this.$window.localStorage.getItem("customfield.__keys");
            if (keys!=null) {
                let arrKeys = keys.split(';');
                for (let key of arrKeys) {
                    if (key !== "") {
                        this.$window.localStorage.removeItem("customfield."+key);
                    }
                }
            }
            this.$window.localStorage.setItem("customfield.__keys", "");
        } else {
            // Sorry! No Web Storage support..
        }
    }

    sendCustomFields(fields) {
        //return;
        for (let key of Object.keys(fields)) {
            this.sendCustomField(key, fields[key]);
        }
    }

    sendCustomField(key, value) {
        try {
            this.equaloneUIService.sendCustomField(key, value);
        } catch(e) {
            console.log(e.message);
        }

    }

}

CustomFieldsService.$inject = ['EQualOneUIService', '$rootScope', '$window'];


// WEBPACK FOOTER //
// ./src/equalone-ui/components/customfields/CustomFieldsService.js